import React from "react";
import { css } from "styled-components";

export default css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
  }

  html,
  body {
    height: 100%;
    background-color: #f5f5f5;
  }

  body {
    max-width: 1366px;
    margin: auto;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  a {
    color: #0284c9;
  }
  .section-pullup {
    position: relative;
    top: -80px;
    width: 100%;
  }
  @media only screen and (min-width: 992px) {
    .section-pullup {
      padding-bottom: 50px;
      top: -50px;
    }
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  @media only screen and (max-width: 767px) {
    .hidden-xs {
      display: none !important;
    }
  }

  body.loading-indicator,
  body.loading-indicator-api {
    overflow: hidden !important;
  }
  body.loading-indicator:before,
  body.loading-indicator-api:before {
    content: "";
    background: #f6f6f694;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9998;
  }

  body.loading-indicator:after,
  body.loading-indicator-api:after {
    content: "";
    background-image: url("/get-quick-quote/assets/ManipalCigna-Loder.gif");
    background-size: contain;
    position: fixed;
    width: 150px;
    height: 150px;
    top: calc(50% - 75px);
    left: calc(50% - 75px);
    z-index: 9999;
    text-align: center;
  }

  .form-content-wrapper .ant-form-item-row {
    display: block;
  }
  .required-marker {
    color: red;
    padding: 0 3px;
    top: -4px;
    position: relative;
    font-size: 15px;
  }

  /*Header css*/
  .banner {
    background-color: #e87d2c;
    position: fixed;
    display: grid;
    top: 0;
    width: 100%;
    /* max-width: 1366px; */
    z-index: 1001;
  }

  .top-sec {
    padding: 6px 0;
    position: relative;
    background-color: #e87d2c;
  }

  .top-sec .log {
    color: #1581c4;
    font-size: 15px;
    background-color: #fff;
    padding: 5px 15px;
    border-radius: 10px 10px 0 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 11;
    height: 35px;
    min-width: 85px;
  }

  .top-sec .log .user_iconn {
    height: 28px;
    line-height: 28px;
    display: inline-block;
    width: 100%;
    text-align: center;
  }

  .nav_bar {
    font-weight: bold;
    // background-color: #ffff;
    // height:100vh;
    // margin: 0px -20px -20px 0px
  }

  .user_iconn a {
    text-decoration: none;
  }
  .top-sec ul {
    list-style: none;
    position: relative;
    z-index: 2;
    margin-right: 115px;
  }

  .top-sec li {
    padding: 0 1.2rem;
    letter-spacing: 0.04rem;
    position: relative;
    float: left;
    font-size: 14px;
    color: #fff;
    line-height: 23px;
    font-weight: bold;
  }

  .ml_1 {
    margin-right: -20px;
    margin-left: -20px;
  }

  .phone_icon {
    position: absolute;
    left: 0;
    top: -1px;
  }

  .bg-telephone_white {
    transform: scale(0.6);
  }

  .bg-telephone_white {
    width: 25px;
    height: 25px;
    background: url(./assets/images/telephone-white.png);
  }
  .top-sec .lang {
    float: right;
    margin: -2px 95px 0px -95px;
    width: 25px;
  }
  .menu_bar {
    margin: 0 0 -4px 0;
    position: relative;
    background: #fff;
   // box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    border-top: 4px solid #1685ca;
    border-radius: 15px 15px 0 0;
    max-height: 100px;
    z-index: 1;
  }
  .menu_lists li:last-child:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 70%;
    top: 15%;
    left: 0;
    background: #fff;
  }

  .menu_lists a {
    text-decoration: none;
  }

  .top_list {
    float: left;
    margin: 0 10px;
  }

  .top_list.haveChild {
    border-width: 0 1px 0;
    border-color: #ffffff;
    border-style: solid;
    padding-right: 30px;
  }

  /*intermediate css*/
  .qq_outer .row {
    margin-right: -10px;
  }
  .qq_outer .col-md-4,
  .qq_outer .col-md-8,
  .qq_outer .col-md-6 {
    padding-right: 10px;
    padding-left: 10px;
  }
  .qq_outer .qq_mrow {
    display: inline-block;
    width: calc(100% + 20px);
  }
  .qq_outer .qq_mrow .col-md-4.w-30 {
    max-width: 330px;
    float: left;
  }
  .qq_outer .qq_mrow .col-md-8.w-70 {
    max-width: 100%;
    width: calc(100% - 330px);
    float: left;
  }
  @media only screen and (min-width: 1225px) {
    .qq_outer .qq_mrow {
      margin-left: -35px;
      width: calc(100% + 45px);
    }
  }

  @media only screen and (min-width: 1199px) {
    .qq_outer .w-30 {
      max-width: 30%;
      flex: 0 0 30%;
    }
    .qq_outer .w-70 {
      max-width: 70%;
      flex: 0 0 70%;
    }
  }

  .qq_outer .col-md-4,
  .qq_outer .col-md-8,
  .qq_outer .col-md-6 {
    padding: 0;
  }

  .fixed {
    max-width: 1164px;
    margin: 0 auto;
    padding: 5px;
  }

  // .card {
  //   border-radius: 0px;
  //   box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  //   display: inline-block;
  //   width: 100%;
  //   border: none !important;
  // }

  // .card,
  // .card-horizontal {
  //   background-color: #f8f9fa;
  //   margin-bottom: 1.5rem;
  //   position: relative;
  // }

  // .card:hover {
  //   box-shadow: 0 0 32.2px 2.8px rgba(244, 126, 31, 0.2);
  // }

  .bg-orange {
    background: #f5851f !important;
    color: #fff;
  }
  .bg_blue {
    background: linear-gradient(to top, #0184c9, #004779);
    height: 32vh;
    width: 100%;
    margin-top: 100px;
  }


  @media only screen and (max-width: 768px) {
    .bg_blue {
      height: 28vh;
      /* margin-top: 100px !important; */
    }
    .ant-picker-dropdown{
      left:80px !important;
    }
  }
  .red {
    color: red;
  }

  .disabled-input:disabled {
    background: #bedce8 !important;
    border: none !important;
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #f5841f;
    z-index: 51;
  }

  .btn-primary-custom {
    font-size: 14px !important;
    background-image: linear-gradient(to top, #f26221, #f5851f) !important;
    border-radius: 100px !important;
    border: none !important;
    padding: 0 30px !important;
    color: #fff !important;
    height: 50px !important;
    line-height: 50px !important;
    cursor: pointer !important;
    text-transform: uppercase !important;
  }

  .btn-primary-custom:hover {
    box-shadow: 0px 10px 20px 0 rgba(245, 133, 31, 0.5);
  }

  .text-link {
    color: #0284c9 !important;
    text-decoration: none;
  }
  .input {
    height: 50px;
    border-radius: 10px;
    border: solid 1px #57585a;
    padding-left: 15px;
    color: #000;
    margin: 0;
    resize: none;
    font-size: 14px;
    box-shadow: none;
  }
  /* Loader */
  // .main_loader {
  //   position: fixed;
  //   background-color: rgba(0, 0, 0, 0.7);
  //   z-index: 100000;
  //   height: 100%;
  //   width: 100%;
  //   left: 0;
  //   top: 0;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  // }

  .round-img {
    background: #e87d2c;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: inline-block;
    margin: 8px 0;
  }

  // .form-control:focus {
  //   // color: #212529;
  //   background-color:#e9ecef;
  // }
`;
